module.exports = __webpack_public_path__ + "static/media/Xlxs.4c62afd8.svg";